import React, { useEffect, useState } from 'react';
import './style.scss';
import { ConsentHeader } from './header';
import { ConsentCheck } from './check';
import { ConsentLink } from './link';
import { ConsentError } from './error';

export type InputConsentProps = {
  title: string;
  name: string;
  checkText: string;
  leftLinkTitle?: string;
  leftLinkUrl?: string;
  rightLinkTitle?: string;
  rightLinkUrl?: string;
  isChecked: boolean;
  setIsChecked: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEnable: boolean;
  errorText?: string;
  batchDangerWord?: string;
};

export const InputConsent = (props: InputConsentProps) => {
  const {
    title,
    name,
    checkText,
    leftLinkTitle,
    leftLinkUrl,
    rightLinkTitle,
    rightLinkUrl,
    isChecked,
    setIsChecked,
    isEnable,
    errorText,
    batchDangerWord,
  } = props;
  const [leftLinkClicked, setLeftLinkClicked] = useState(false);
  const [rightLinkClicked, setRightLinkClicked] = useState(false);

  return (
    <div className="inputWrapper">
      <ConsentHeader headerTitle={title} batchDangerWord={batchDangerWord} />
      <fieldset className={name}>
        <ConsentCheck name={name} text={checkText} isChecked={isChecked} setIsChecked={setIsChecked} disabled={!leftLinkClicked} />
      </fieldset>
      <div className="inputWrapper_horizontal">
      <ConsentLink linkTitle={leftLinkTitle} linkUrl={leftLinkUrl} onClick={() => setLeftLinkClicked(true)} />
      <ConsentLink linkTitle={rightLinkTitle} linkUrl={rightLinkUrl} onClick={() => setRightLinkClicked(true)} />
      </div>
      <ConsentError isEnabled={isEnable} errorText={errorText} />
    </div>
  );
};
